module.exports = __webpack_public_path__ + "static/media/ico_celulitis.21e326d7.svg";